import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from './handlers';
import { get } from '../utils/cookies';

declare const window: any;

export const profileApi = createApi({
    reducerPath: 'profileApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.MCP_PROFILE_SERVICE_API ?? 'https://development.profile.cimpress.io/',
    }),
    endpoints: (builder) => ({
        getProfile: builder.query({
            query: () => {
                const { token, type } = window.authfrontSDK.getAuthorization();
                return {
                    url: `v1/${window.Config?.MCP_ACCOUNT_ID}/profile/me`,
                    method: 'GET',
                    headers: {
                        'Authorization': `${type} ${token}`,
                    }
                }
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                } catch (error) {
                    dispatch(onErrorHandler({ operation: 'getProfile', err: JSON.stringify(error), errMsg: 'Error: while getting customer profile from mcp.', api: `${window.Config?.MCP_PROFILE_SERVICE_API}v1/${window.Config?.MCP_ACCOUNT_ID}/profile/me` }));
                }
            },
        }),
        updateProfile: builder.mutation({
            query: ({ newPassword }) => {
                const { token, type } = window.authfrontSDK.getAuthorization();
                return {
                  url: `v1/${window.Config?.MCP_ACCOUNT_ID}/profile/me/password`,
                  method: "PUT",
                  body: { newPassword },
                  headers: {
                    Authorization: `${type} ${token}`,
                  },
                };
              },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                } catch (error) {
                    onErrorHandler({
                        operation: "getProfile",
                        err: JSON.stringify(error),
                        errMsg: "Error: while updating customer profile from MCP.",
                        api: `${window.Config?.MCP_PROFILE_SERVICE_API}v1/${window.Config?.MCP_ACCOUNT_ID}/profile/me/password`,
                    })
                }
            },
        })
    }),
})

export const {
    useGetProfileQuery,
    useUpdateProfileMutation,
} = profileApi;
